import { Strong, Text } from 'braid-design-system';
import translations from './.vocab';
import { useTranslations } from '@vocab/react';

export const CertsyLegalDisclaimer = () => {
  const { t } = useTranslations(translations);
  return (
    <Text size="small">
      {t('Legal disclaimer', {
        Strong: (children) => (
          <Strong key={`legal-disclaimer-${children}`}>{children}</Strong>
        ),
      })}
    </Text>
  );
};
